import { useState } from "react";
import { useApi } from "providers/ProvideApi";
import { wrapError } from "../../utils";

export const useGetAssistJobResults = () => {
  const { authApi } = useApi();
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState(null);

  const getAssist = async (id) => {
    try {
      setIsUpdating(true);
      setError(null);
      const response = await authApi.get(`/api/assistant/job/${id}/results`);
      return response.data;
    } catch (e) {
      const error = wrapError(e);
      setError(error);
    } finally {
      setIsUpdating(false);
    }
  };

  return [getAssist, isUpdating, error];
};

export default useGetAssistJobResults;
